import { Navigate, Route, useLocation } from "react-router-dom";
import { PlanType } from "sdk/types";
import { leaves } from "~/constants";
import { useQuery } from "~/hooks/useQuery";
import { Protector } from "./Protector";
import { lazy, lazyLoadLandingPages, rrPath } from "./utils";

const ForgotPasswordPage = lazyLoadLandingPages("ForgotPasswordPage");

const ResetPasswordPage = lazyLoadLandingPages("ResetPasswordPage");

const SignInPage = lazyLoadLandingPages("SignInPage");

const types: PlanType[] = ["plus", "premium"];

const SignUpWrapper = () => {
  const location = useLocation();
  const query = useQuery();
  const type = query.get("type");

  const typeState = types.includes(type as any) ? { type } : {};
  const locationState = { ...typeState, ...location.state };

  return <Navigate to={leaves.onboardingRoot} state={locationState} />;
};

export const AuthNRoutes = (
  <>
    <Route path={leaves.apply}>
      <Route
        path={rrPath(leaves.tryingToConceive)}
        element={<SignUpWrapper />}
      />
    </Route>
    <Route
      path={leaves.signIn}
      element={<Protector protectAuth>{lazy(<SignInPage />)}</Protector>}
    />
    <Route
      path={leaves.forgotPassword}
      element={
        <Protector protectAuth>{lazy(<ForgotPasswordPage />)}</Protector>
      }
    />
    <Route
      path={leaves.resetPassword}
      element={<Protector protectAuth>{lazy(<ResetPasswordPage />)}</Protector>}
    />
  </>
);
